/**
 * Viñedo hero — intro zoom out al cargar (estilo sitio estático / San Felice).
 */
(function () {
  const START_SCALE = 1.14;
  const END_SCALE = 0.9;
  const DURATION_MS = 2400;

  /**
   * @param {HTMLElement} hero
   */
  function initVinedoHeroIntro(hero) {
    const frame = hero.querySelector('.vinedo-hero__media-frame');
    if (!frame || frame.dataset.vinedoIntroInit === 'true') return;

    frame.dataset.vinedoIntroInit = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      frame.style.transform = 'scale(1)';
      return;
    }

    const startTime = performance.now();
    frame.style.transition = 'none';
    frame.style.transform = `scale(${START_SCALE})`;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function tick(now) {
      const t = Math.min((now - startTime) / DURATION_MS, 1);
      const scale = START_SCALE + (END_SCALE - START_SCALE) * easeOutCubic(t);
      frame.style.transform = `scale(${scale})`;

      if (t < 1) {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  }

  function initAllVinedoHeroes() {
    document.querySelectorAll('.vinedo-hero').forEach(initVinedoHeroIntro);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllVinedoHeroes);
  } else {
    initAllVinedoHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const hero = event.target.matches?.('.vinedo-hero')
      ? event.target
      : event.target.querySelector?.('.vinedo-hero');

    if (hero) {
      const frame = hero.querySelector('.vinedo-hero__media-frame');
      if (frame) delete frame.dataset.vinedoIntroInit;
      initVinedoHeroIntro(hero);
    }
  });
})();
